import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useFunnelStore } from "@/store";
import { useStepperStore } from "@/store/stepper";
import { apiClient } from "@/shared/lib/api-client";
import { API_ENDPOINTS } from "@/shared/constants/api-endpoints";

export const Route = createFileRoute("/code/$code")({
  component: CodeLanding,
});

/**
 * QR-scan landing — `secretmissions.com/code/<code>`. Scanning a KEY QR sends
 * the visitor here. We resolve who the KEY belongs to (so the intro greets by
 * name), clear any prior run, reset the stepper to its first step, and drop the
 * visitor into the funnel at the very top.
 */
function CodeLanding() {
  const navigate = useNavigate();
  const { code } = Route.useParams();
  const resetFunnel = useFunnelStore((s) => s.resetFunnel);

  useEffect(() => {
    if (code) localStorage.setItem("secret-missions-ref", code);
    resetFunnel();
    void (async () => {
      // Resolve the referrer name so the intro can greet by name. Best-effort —
      // a failure just falls back to the neutral "Someone gave you a one-use key."
      if (code) {
        try {
          const { data } = await apiClient.get(API_ENDPOINTS.qr.referrer(code));
          const name = data?.result?.referrerName as string | undefined;
          if (name) useFunnelStore.getState().setReferrerName(name);
        } catch {
          /* ignore */
        }
      }
      const store = useStepperStore.getState();
      if (store.status === "idle" || store.status === "error")
        await store.load();
      // Force back to the first step even for a returning visitor.
      useStepperStore.getState().reset();
      navigate({ to: "/", replace: true });
    })();
    // Mount-only: a scan always restarts the run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <p className="text-center font-mono text-[11px] tracking-[0.22em] text-muted-foreground uppercase">
      Decrypting your orders…
    </p>
  );
}
